import { useOutsideClick } from "../Hooks/useOutsideClick";
import "./DarkPopover.scss";

// const Menu = styled.div<Props>`
// font-size: 12 px;
// position: absolute;

// z-index: 9999;
//   background-color: rgba(65, 59, 56, 0.92);

//   color: #ffffff;
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
//   justify-content: center;
//   padding: 10px 8px;
//   border-radius: 5px;
//   transition: none;

//   a {
//     font-size: 14 px;
//     font-weight: 400;
//     color:#ffffff;
//     b {
//         font-weight: 600;
//     }
//     margin-bottom: 8px;
//     cursor: pointer;
//     &:last-child {
//         margin-bottom: 0;
//         }
//     }
//     &:hover {
//       color:#F67902;
//     }

// `;
interface Props {
  top?: number;
  left?: number;
  right?: number;

  width?: number;
  children?: any;
  clickedOutside?: () => void;
}
export function DarkPopover(props: Props) {
  const handleClickOutside = () => {
    if (props.clickedOutside) {
      props.clickedOutside();
    }
  };
  const ref = useOutsideClick(handleClickOutside);

  let style: React.CSSProperties = {
    top: "35px"
  };
  if (props.top) {
    style.top = props.top + "px";
  }
  if (props.left) {
    style.left = props.left + "px";
  }
  if (props.right) {
    style.right = props.right + "px";
  }
  if (props.width) {
    style.width = props.width + "px";
    style.minWidth = props.width + "px";
  }

  return (
    <div ref={ref} className="DarkPopover Popover" style={style}>
      {props.children}
    </div>
  );
}
